// SINGLE EXHIBITION SUBPAGE, USED IN ExhibitionList.js

import React, { useContext } from "react";
import MetaTags from "react-meta-tags";
import { LanguageContext } from "./../language-context";
import * as variables from "./helper/Variables";
import { pl } from "./../data/pl";
import styled from "styled-components";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { PageTitle } from "./helper/PageTitle";
import { Exhibition } from "./Exhibition";
import { Scroll } from "./helper/Scroll";
import "react-lazy-load-image-component/src/effects/blur.css";
import { ImageGallery } from "./ImageGallery";

const ImageContainer = styled.div`
  ${variables.Flex};
  ${variables.DimensionsView};
  padding: 0 2rem;
  background-color: ${variables.BACKGROUND_GRAY};
`;

const Image = styled(LazyLoadImage)`
  max-height: 80%;
  width: auto;
  opacity: 0;
  animation: ${variables.ChangeOpacity} 0.5s 0.1s linear forwards;

  @media (max-width: 900px) and (orientation: portrait) {
    width: 95%;
    height: auto;
  }
`;

export const ExhibitionItem = () => {
  const usedLanguage = useContext(LanguageContext);

  const exhibitionId = window.location.href.slice(-4);

  const { exhibitionTitle } =
    usedLanguage.language.exhibitions.exhibitionsContainer[
      window.location.href.slice(-4)
    ];

  const { exhibitionImages } =
    pl.exhibitions.exhibitionsContainer[window.location.href.slice(-4)];

  const images = [];

  Object.keys(exhibitionImages).map((exhibitionImage) => {
    images.push(
      `./../images/exhibitions/${exhibitionId}/${exhibitionImage}.jpg`
    );
  });

  Scroll();

  return (
    <main>
      <MetaTags>
        <title>{exhibitionTitle} | Structuralist</title>
        <meta name="description" content={exhibitionTitle} />
        <meta
          name="keywords"
          content={`"Structuralist", "Michał Król", ${exhibitionTitle}`}
        />
      </MetaTags>
      <PageTitle
        text={exhibitionTitle}
        backgroundColor={variables.BACKGROUND_GRAY} //Styled Components props
      ></PageTitle>
      <Exhibition exhibitionId={window.location.href.slice(-4)}></Exhibition>
      <ImageContainer>
        <ImageGallery imageSources={images} />
      </ImageContainer>
    </main>
  );
};
